import styled from "@emotion/styled"

const ArticleRelatedArticleInfo = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    gap: 30px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    gap: 20px;
  }
`

export default ArticleRelatedArticleInfo